//css

//import IsDarkOrNot from "./scroll-stuff/IsDarkOrNot";

import AOS from "aos";

require("./fk-main.less");
require("slick-carousel");
require("slick-carousel/slick/slick.css");

import MainMenu from "./layout/MainMenu";
import PageTransitionDash from "./transitions/PageTransitionDash";
import TypoResize from "./typo/TypoResize";
import Affix from "./scroll-stuff/Affix";
import Slick from "./plugins-relay/Slick";
import VideoPlyr from "./plugins-relay/VideoPlyr";
import GoogleMap from "./plugins-relay/GoogleMap";
//import ScrollListener from "./scroll-stuff/ScrollListener";
import FkPerfectScroll from "./scroll-stuff/FkPerfectScroll";
//import {TimelineStuff, TimelineCadres,TimelinePoster} from './scroll-stuff/timeline-classes';
import DataSocialShareClick from "data-social-share-click";
import FkContactForm from "./forms/FkContactForm";
import PrevNext from "./prev-next/PrevNext";



require("./btns/btn-ico.less");
require("./css-variables-polyfill");

/**
 * Gère à peu près tout dans un site FK prod, lab ou studio
 */
export default class FkMain{

    constructor() {
        /**
         *
         * @type {FkMain}
         */
        let me = this;
        /**
         * Le menu de nav principale
         * @type {MainMenu}
         */
        this.mainMenu = new MainMenu();
        /**
         * Le masque de transition entre deux pages
         * @type {PageTransitionDash}
         */
        this.transition = new PageTransitionDash();
        /**
         *
         * @type {ScrollListener}
         */
        //this.scrollStuff=new ScrollListener();

        //teste lsi la nav doit etre foncée ou claire
        //this.isDarkOrNot= new IsDarkOrNot();

        this._initListeners();


        let socialShares=new DataSocialShareClick();
        socialShares.listenClicks();


        //---------------------go------------------------------------------


        //les autres modules en auront besoin...
        window.FK = this;
        //on ferme au départ histoire que toutes les propriétés soient ok
        this.mainMenu.close();

        require("./components/data-cats");
        require("./components/aos");

        this.resizeStage();
        me.transition.hidePage(null, 0.00001);
        me.onDomChange();
        me.transition.showPage();
        //new FkPerfectScroll($main);
        window.cqEventsListener.addObject(FkContactForm);



    }



    /**
     * Affiche ou pas le logo
     * @param show
     */
    showLogo(show=true){
        if(show){
            $("#logo").removeClass("masked");
        }else {
            $("#logo").addClass("masked");
        }
        //TweenMax.to($("#logo"), 0.5, {y: show === true ? 0 : -200 });
    }


    /**
     * smooth scroll vers un element
     * @param $el
     */
    scrollToElement($el){
        let y=$el.offset().top;
        TweenLite.to(window, 0.4, {
            scrollTo:{
                "y":y, "x":0
            }
        });
    }

    /**
     * Remet le scroll à zéro
     */
    scrollToTop(){
        $(window).scrollTop(0);
    }

    /**
     *
     * @private
     */
    _initListeners() {

        let me=this;

        require("./components/data-zoom-img");

        //ferme le menu quand on change d'url
        $body.on(EVENTS.HISTORY_CHANGE_URL,function(){
            //ferme menu
            me.mainMenu.close();
            me.showLogo(true);
            //me.scrollStuff.destroy();
            //stope en attendant que la transition soit finie
            PovHistory.readyToinject=false;
            me.transition.hidePage(
                function(){
                    //dit qu'on est prêt à afficher la page (s'assure qu'on reste au moins une seconde sur l'écran de transition)
                    setTimeout(function(){
                        PovHistory.readyToinject=true;
                    },100)

                }
            );
        });

        //changement d'url et HTML injecté
        $body.on(EVENTS.HISTORY_CHANGE_URL_LOADED_INJECTED,function(){
            me.onDomChange();
            me.scrollToTop();

            /**
             * Affiche la page en s'assurant qu'avant de le faire il n'y a pas dans la page une classe .page-not-ready
             */
            function affichePageIfReady(){
                //teste si la page est prête
                let pageNotReady=$main.find(".page-not-ready").length>0;
                if(pageNotReady){
                    console.log("page not ready",$main.find(".page-not-ready"));
                    //rééssayera plus tard
                    setTimeout(function(){
                        affichePageIfReady();
                    },300);
                }else{
                    setTimeout(function(){
                        //transition affiche page
                        me.transition.showPage(
                            function(){
                                //ferme menu
                                me.mainMenu.close();//
                                //refresh aos
                                if(window.AOS){
                                    AOS.refresh();
                                }
                                if(typeof gtag !== 'undefined' && LayoutVars.googleAnalyticsId){
                                    //hit google analytics
                                    gtag('config', LayoutVars.googleAnalyticsId, {'page_path': location.pathname});
                                }

                            }
                        );
                    },100)
                }
            }

            affichePageIfReady();

        });

        STAGE.on(EVENTS.RESIZE,function(){
            me.resizeStage();
        });

        $body.on(Pov.events.DOM_CHANGE,function(){
            me.onDomChange();
        });

        $body.on("click","[href='#scroll-next']",function(e){
            e.preventDefault();
           let $next=$(this).closest("section").next();
           me.scrollToElement($next);
        });

        /**
         * Autorize le mousewheel sur des fixed .js-wheel
         */
        $body.on("mousewheel DOMMouseScroll",".js-wheel",function(event){
            $main.scrollTop($main.scrollTop() - (event.originalEvent.wheelDelta || -event.originalEvent.detail*30));
        });



    }



    /**
     * Adapte des élements à l'écran
     */
    resizeStage(){
        //this.transitionLayer.resize();
        //this.scrollStuff.resizeScenes();
        TypoResize.refresh();
        window.refreshDisplay();
    }

    /**
     * Initialisations d'objets dom
     */
    onDomChange(){
        //PageVideo.initFromDom();
        VideoPlyr.initFromDom();
        Affix.initFromDom();
        GoogleMap.initFromDom();
        //TimelineStuff.initFromDom();
        //this.scrollStuff.buildScenes();
        TypoResize.refresh();
        Slick.initFromDom();
        //prev / next
        PrevNext.initFromDom();
        window.refreshDisplay();




    }



    /**
     * Définit la couleur du logo et du burger
     * @param {String} burgerColor white ou black
     * @param {String} logoColor white ou black ou fk
     */
    setNavColor(burgerColor,logoColor){
        //console.error("setNavColor "+burgerColor+" / "+logoColor);
        $("#toggle-nav").attr("data-color",burgerColor);
        //$("#logo").attr("data-color",logoColor);
    }

}
window.FkMain=FkMain;


// WEBPACK FOOTER //
// ./fk.app/_src/FkMain.js